// The preset color palette for geofences
export const COLORS = [
    "#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3",
    "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39",
    "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"
];

export const GEOFENCE_NAME_MAX_LENGTH = 32;
export const DEFAULT_RADIUS = 100;
export const NEW_GEOFENCE_NAME = 'New Geofence';
export const DEFAULT_GEOFENCE_TYPE = 'Point';

export const PROPORTIONATE_RADIUS_SIZES = {
    BIG: "big",
    MEDIUM: "medium",
    SMALL: "small"
}
